"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemePrefer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _constants = require("../utils/constants");
var shouldUpdate = true;
function queryDarkTheme() {
  if (window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)');
  } else return false;
}
var useThemePrefer = exports.useThemePrefer = function useThemePrefer() {
  var _useState = (0, _react.useState)(function () {
      var media = queryDarkTheme();
      if (media) {
        return media.matches;
      } else {
        return false;
      }
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    preferDark = _useState2[0],
    setPreferDark = _useState2[1];
  // Listen the print lift cycle
  // Prevent the state changed during printing
  // Which would cause the page freezed
  (0, _react.useEffect)(function () {
    function handlerBeforePrint() {
      shouldUpdate = false;
    }
    function handlerAfterPrint() {
      shouldUpdate = true;
    }
    window.addEventListener('beforeprint', handlerBeforePrint);
    window.addEventListener('afterprint', handlerAfterPrint);
    return function () {
      window.removeEventListener('beforeprint', handlerBeforePrint);
      window.removeEventListener('afterprint', handlerAfterPrint);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var media = queryDarkTheme();
    if (media) {
      var handler = function handler(e) {
        if (media.matches !== preferDark) {
          if (shouldUpdate) {
            setPreferDark(media.matches);
          }
        }
      };
      handler();
      media.addListener(handler);
      return function () {
        return media.removeListener(handler);
      };
    }
  }, [preferDark]);
  return preferDark ? _constants.themeMode.DARK : _constants.themeMode.LIGHT;
};
//# sourceMappingURL=themePrefer.js.map